export default __webpack_public_path__ + "static/media/reboot-hover.239273a9.svg";